import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { resetPasswordFormSchema } from './reset-password-form.schema';

export const useResetPasswordForm = () => {
  return useForm({
    resolver: yupResolver(resetPasswordFormSchema),
    defaultValues: {
      email: '',
    },
  });
};
